<template>
    <div>
      <el-form v-if="!isApproval" label-position="top" size="mini"  style="height:400px;overflow-y: auto" class="data-operate">
          <el-row>
            <el-col :span="10">
                <el-form-item label="数据类型">
                    <el-radio-group v-if="dataOperate.dataSource===2" v-model="dataOperate.dataSource" size="mini" class="operate-type">
                        <!-- <el-radio disabled :label="0">普通表单</el-radio>
                        <el-radio disabled :label="1">任务表单</el-radio> -->
                        <el-radio :label="2">流程表单</el-radio>
                    </el-radio-group>
                     <el-radio-group v-else v-model="dataOperate.dataSource" size="mini" class="operate-type">
                        <el-radio disabled :label="0">普通表单</el-radio>
                        <el-radio :label="1">任务表单</el-radio>
                        <!-- <el-radio disabled :label="2">流程表单</el-radio> -->
                    </el-radio-group>
                      <el-tooltip v-if="dataOperate.forms && dataOperate.forms.length>0" content="1.如果还需进行【表单权限】配置，请点击【实时保存表单】后再进行【表单权限】配置。2.或者点击下方的【保存配置】后，再次打开该任务进行【表单权限】配置" effect="light" placement="top">
                          <el-badge class="badge-item" v-permission="permission.designProcessTemplateBtn">
                              <el-button style="margin-left:50px" type="primary" @click="saveConfig">实时保存表单</el-button>
                          </el-badge>
                      </el-tooltip>
                </el-form-item>
            </el-col>
            <el-col :span="4"></el-col>
            <el-col :span="10">
                <el-form-item label="表单数据源">
                    <!-- style="height:200px;overflow-y: auto" -->
                    <div v-if="this.dataOperate.dataSource >=1"  >
                            <!-- <TreeSelect
                                ref="treeSelect"
                                :sourceOptions="appModelsOptions"
                                :multiple="true"
                                @treeSelectChoose="handleSelectForm"
                            />   -->
                            <TreeSelect
                                :isRead="isRead"
                                ref="treeSelect"
                                :sourceOptions="appModelsOptions"
                                @treeSelectChoose="handleSelectForm"
                            />
                    </div>
                    <div v-else-if="this.dataOperate.dataSource === 0">
                            <el-autocomplete
                                label='formName'
                                placeholder="请输入名称"
                                v-model.trim="selectFormItem"
                                :fetch-suggestions="handleQueryForm"
                                @select="handleSelectForm">
                                <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                            </el-autocomplete>
                    </div>
                </el-form-item>
            </el-col>
         </el-row>
        <el-row>
            <el-form-item label="所选表单">
                <!-- <el-select v-model="dataOperate.formId" placeholder="请选择">
                    <el-option v-for="form in formList" :label="form.formName" :value="form.id" :key="form.id"></el-option>
                </el-select> -->
                <div class="select-forms">
                    <span
                        class="forms-item"
                        v-for="(form, index) in dataOperate.forms"
                        :key="form.id">
                        {{form.formName}}
                        <i class="executor-del el-icon-circle-close" @click.stop="handleDeleteForm(index)" title="删除"></i>
                    </span>
                </div>
            </el-form-item>
        </el-row>
        <el-row>
            <el-form-item label="关联报表">
                <TreeSelect
                    ref="reportTreeSelect"
                    :isRead="isRead"
                    :sourceOptions="reportModelsOptions"
                    @treeSelectChoose="handleSelectReport"
                />
            </el-form-item>
        </el-row>
        <!-- <el-row>
            <el-col :span='2' :offset="11">
                <el-tooltip  content="如果还需进行【表单权限】配置，请点击【保存】后再进行【表单权限】配置或点击下方的【保存配置】后，再次打开该任务进行【表单权限】配置" effect="light" placement="top">
                    <el-badge class="badge-item" v-permission="permission.designProcessTemplateBtn">
                        <el-button type="primary" @click="saveConfig">保存</el-button>
                    </el-badge>
                </el-tooltip>
            </el-col>
        </el-row> -->
    </el-form>
    <template v-if="isApproval">
        <el-form-item label="审批表单" v-if="!isTimeConfig"
         prop="dataOperate.forms"
         :rules="[
            { required: true, message: '请选择审批表单', trigger: 'change' },
          ]"
        >
            <TreeSelect
                :isRead="isRead"
                ref="treeSelect"
                :sourceOptions="appModelsOptions"
                @treeSelectChoose="handleSelectForm"
            />
        </el-form-item>
        <el-form-item label="项目模板表单" v-if="isTimeConfig"
         prop="dataOperate.forms">
            <TreeSelect
                :isRead="isRead"
                ref="treeSelect"
                :sourceOptions="appModelsOptions"
                @treeSelectChoose="handleSelectForm"
            />
        </el-form-item>
        <!-- <el-form-item label="所选表单"
         :rules="[
            { required: true, message: '请选择审批表单', trigger: 'blur' },
          ]"
        >
            <div class="select-forms">
                <span
                    class="forms-item"
                    v-for="(form, index) in dataOperate.forms"
                    :key="form.id">
                    {{form.formName}}
                    <i class="executor-del el-icon-circle-close-outline" @click.stop="handleDeleteForm(index)" title="删除"></i>
                </span>
            </div>
        </el-form-item> -->
    </template>
  </div>
</template>

<script>
    import { getFormAllConfig, getApplicationModelTreeList } from '@/data-model';
    import TreeSelect from '@/components/TreeSelect';
    import { cloneDeep } from 'lodash';
    import { CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN } from '@/common/constants';

    export default {
        components: {
            TreeSelect
        },
        data () {
            return {
                selectFormItem: undefined,
                reportModelsOptions: [],
                appModelsOptions: [],
                permission: {
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ]
                }
            };
        },
        watch: {
            dataOperate (newVal, oldVal) {
                this.initTreeSelect(newVal.forms);
            },
            dataSource (newVal, oldVal) {
                if (newVal >= 1) {
                    this.initTreeSelect(this.dataOperate.forms);
                }
            }
        },
        props: {
            dataOperate: {
                type: Object
            },
            dataSource: {
                type: Number
            },
            isApproval: {
                type: Boolean,
                default: false
            },
            isTimeConfig: {
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // console.log(this.dataOperate.dataSource);
            this._initPage();
        },
        methods: {
            saveConfig () {
                this.$emit('saveConfig', true);
            },
            async _initPage () {
                this.getApplicationModelTreeList();
                this.getReportList();
            },
            async getApplicationModelTreeList () {
                let modelTree = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 0
                });
                if (modelTree) {
                    this.appModelsOptions = modelTree;
                }
                this.initTreeSelect(this.dataOperate.forms);
            },
            // 挂载报表模型
            async getReportList () {
                let reportTree = await getApplicationModelTreeList({
                    currentPage: 1,
                    pageSize: 100,
                    state: 1,
                    modelType: 2
                });
                if (reportTree) {
                    this.reportModelsOptions = reportTree;
                }
                this.initReportTreeSelect();
            },
            initReportTreeSelect () {
                if (this.dataOperate.reports) {
                    setTimeout(() => {
                        let selectedTree = [];
                        this.dataOperate.reports.forEach((item) => {
                            if (item.modelId) {
                                selectedTree.push(item.modelId);
                            }
                        });
                        if (this.$refs.reportTreeSelect) {
                            this.$refs.reportTreeSelect.initParam(selectedTree);
                        }
                    }, 0);
                }
            },
            handleSelectReport (selectObj) {
                let selectedModel = cloneDeep(selectObj);
                if (Array.isArray(selectedModel)) {
                    let tempArr = [];
                    selectedModel.forEach(item => { // 再补充本次选择的
                        item.modelId = item.id;
                        item.id = item.formId;
                        item.formName = item.name;
                        item.dataSource = 2;
                        tempArr.push(item);
                    });
                    // this.addForms(item);
                    this.dataOperate.reports = tempArr;
                }
                // console.log(this.dataOperate.forms);
            },
            initTreeSelect (formObj) {
                if (this.dataOperate.forms) {
                    setTimeout(() => {
                        let selectedTree = [];
                        this.dataOperate.forms.forEach((item) => {
                            if (item.modelId) {
                                selectedTree.push(item.modelId);
                            }
                        });
                        if (this.$refs.treeSelect) {
                            this.$refs.treeSelect.initParam(selectedTree);
                        }
                    }, 0);
                }
            },
            async handleQueryForm (queryString, cb) {
                let queryList;
                // 已经选择的id列表
                let selectedIds = this.dataOperate.forms.map(item => {
                    return item.formId;
                });
                // console.log(this.dataOperate.dataSource);
                let { data } = await getFormAllConfig({
                    formName: queryString,
                    formType: this.dataOperate.dataSource
                });
                queryList = data;

                cb(queryList.filter(item => {
                    return selectedIds.indexOf(item.id) === -1;
                }).map(item => {
                    item.value = item.formName;
                    return item;
                }));
            },
            handleSelectForm (selectObj) {
                if (this.dataOperate.dataSource >= 1) {
                    let selectedModel = cloneDeep(selectObj);
                    if (Array.isArray(selectedModel)) {
                        let tempArr = [];
                        // 已经选择的id列表
                        this.dataOperate.forms.map(item => {
                            if (item.dataSource === 0) { // 先筛选出流程表单
                                tempArr.push(item);
                            }
                        });
                        selectedModel.forEach(item => { // 再补充本次选择的
                            item.modelId = item.id;
                            item.id = item.formId;
                            item.formName = item.name;
                            item.dataSource = 1;
                            tempArr.push(item);
                        });
                        // this.addForms(item);
                        this.dataOperate.forms = tempArr;
                    }
                } else {
                    selectObj.dataSource = 0;
                    this.addForms(selectObj);
                }
                // console.log(this.dataOperate.forms);
                this.selectFormItem = undefined;
            },
            addForms (selectObj) {
                Array.isArray(this.dataOperate.forms) && (this.dataOperate.forms.push({
                    formId: selectObj.id,
                    modelId: selectObj.modelId,
                    formName: selectObj.formName,
                    dataSource: selectObj.dataSource,
                    viewOrder: this.dataOperate.forms.length
                }));
            },
            handleDeleteForm (index) {
                this.dataOperate.forms.splice(index, 1);
                // 删除元素会造成排序字段不连续
                this.sortDataOperate();
                if (this.dataOperate.dataSource >= 1) {
                    this.initTreeSelect(this.dataOperate.forms);
                }
            },
            sortDataOperate () {
                // 重新设置排序字段
                if (this.dataOperate.forms && Array.isArray(this.dataOperate.forms)) {
                    for (let index = 0, len = this.dataOperate.forms.length; index < len; index++) {
                        this.dataOperate.forms[index].viewOrder = index;
                    }
                }
            }
        }
    };
</script>

<style lang="less">
    .data-operate {
        .select-forms {
            display: flex;
            flex-wrap: wrap;
        }

        .forms-item {
            border: 1px solid #ffffff;
            font-size: 12px;
            width: 150px;
            min-width: 100px;
            margin: 5px 5px 0 0;
            padding: 0 5px;

            display: flex;
            justify-content: space-between;
            align-items: center;
            & > i {
                visibility: hidden;
                cursor: pointer;
            }
        }

        .forms-item:hover {
            border: 1px solid #e4e7ed;
            & > i {
                visibility: visible;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/DataOperateEdit.vue